import { clients } from '../../../util/clients';
import { configUrls } from '../../../util/clients/client-config';

const trimNumber = (value) => {
  const rounded = Math.round(value * 10) / 10;
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
};

/** Row label helper. Returns '' for a missing size rather than "NaN B". */
export const humanSize = (bytes) => {
  const size = Number(bytes);
  if (!size || Number.isNaN(size)) return '';
  if (size < 1024) return `${size} B`;
  const kb = size / 1024;
  if (kb < 1024) return `${trimNumber(kb)} KB`;
  return `${trimNumber(kb / 1024)} MB`;
};

// The bytes come from the county backend, which proxies them from the admin
// backend — county browsers cannot reach the admin backend directly.
export const attachmentDownloadPath = (announcementId, blobName) => `/announcements/${encodeURIComponent(announcementId)}/attachments/${encodeURIComponent(blobName)}`;

export const attachmentDownloadUrl = (announcementId, blobName) => (
  `${configUrls().BACKEND_REST}${attachmentDownloadPath(announcementId, blobName)}`
);

/**
 * Fetches the attachment and hands it to the browser as a download.
 *
 * The route is behind this backend's JWT check, and a plain <a href> navigation
 * sends no Authorization header. The alternative the auth middleware allows —
 * `?token=<jwt>` — would put a live session token in browser history, referrers
 * and access logs, so the bytes are fetched with the authed axios client and
 * saved from an object URL instead.
 */
export const downloadAttachment = async (announcementId, attachment, {
  restClient = clients.direct.backendRest,
  doc = document,
  urlApi = window.URL,
} = {}) => {
  const response = await restClient.get(
    attachmentDownloadPath(announcementId, attachment.blobName),
    { responseType: 'blob' },
  );

  const objectUrl = urlApi.createObjectURL(response.data);
  try {
    const link = doc.createElement('a');
    link.href = objectUrl;
    link.download = attachment.filename || attachment.blobName;
    doc.body.appendChild(link);
    link.click();
    link.remove();
  } finally {
    // The blob stays in memory for the life of the document otherwise.
    urlApi.revokeObjectURL(objectUrl);
  }
};

export default {
  attachmentDownloadPath,
  attachmentDownloadUrl,
  downloadAttachment,
  humanSize,
};
